<div class="">
	<div class=" font-bold text-[#3c3c3c] mb-2">
		{{sizeProfile.displayName? sizeProfile.displayName : 'Choose Size'}}
	</div>
	<div *ngIf="selectedSize" class="mb-2 text-xs grey-text">
		{{selectedSize.keyFeature}}
	</div>
	<div *ngIf="product.customSizeProfileEnabled && product.customSizeProfile && customSizeSubmitted"
		 class="mb-2 text-xs flex gap-1 flex-wrap grey-text">
		<span *ngFor="let custom of product.customSizeProfile.customSizeProfileItemList; let i = index">
			{{custom.label}}: {{customSizeFormGroup.get(custom.label)?.value}} {{i !== product.customSizeProfile.customSizeProfileItemList.length - 1 ? ', ' : ''}}
		</span>
	</div>
	<div *ngIf="sizeProfile.sizeProfileOptionList && sizeProfile.sizeProfileOptionList.length > 0"
		 class="flex justify-start items-center flex-wrap gap-2">
		<button class="fb-size-btn"
				(click)="selectSize(size)"
				[class.active]="selectedSizeLabel === size.label"
				*ngFor="let size of sizeProfile.sizeProfileOptionList">
			{{size.label}}
		</button>
		<button class="fb-size-btn flex items-center gap-1"
				[class.active]="selectedSizeLabel === 'custom'"
				(click)="selectCustom(product.customSizeProfile)"
				*ngIf="product.customSizeProfileEnabled && product.customSizeProfile">
			<div class="">Custom {{product.productGroup === 'finished' ? 'Size' : 'Dye'}}</div>
		</button>

		<button (click)="openSizeGuideDialog()" class="fb-size-btn flex items-center gap-1">
			<div class=""><span *ngIf="product.productGroup === 'finished'">Size</span> Guide</div>
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_2157_250)">
					<path d="M7.99988 0.159912C3.67691 0.159912 0.159912 3.67691 0.159912 7.99988C0.159912 12.3229 3.67691 15.8399 7.99988 15.8399C12.3229 15.8399 15.8399 12.3229 15.8399 7.99988C15.8399 3.67691 12.3229 0.159912 7.99988 0.159912ZM7.99988 3.37431C8.20148 3.37431 8.39855 3.43411 8.56615 3.54608C8.73378 3.65808 8.86438 3.81725 8.94155 4.00348C9.01868 4.18975 9.03888 4.39465 8.99948 4.59235C8.96018 4.79005 8.86315 4.97168 8.72058 5.11418C8.57805 5.25675 8.39645 5.35378 8.19871 5.39315C8.00105 5.43248 7.79608 5.41228 7.60985 5.33515C7.42361 5.25798 7.26448 5.12735 7.15248 4.95978C7.04048 4.79215 6.98071 4.59508 6.98071 4.39351C6.98071 4.12321 7.08811 3.86395 7.27925 3.67281C7.47035 3.48168 7.72958 3.37431 7.99988 3.37431ZM9.88151 12.2335H6.43191C6.26558 12.2335 6.10605 12.1674 5.98838 12.0498C5.87081 11.9322 5.80471 11.7726 5.80471 11.6063C5.80471 11.44 5.87081 11.2804 5.98838 11.1628C6.10605 11.0452 6.26558 10.9791 6.43191 10.9791H7.52951V7.52951H6.90231C6.73598 7.52951 6.57641 7.46341 6.45881 7.34585C6.34121 7.22818 6.27511 7.06865 6.27511 6.90231C6.27511 6.73598 6.34121 6.57645 6.45881 6.45881C6.57641 6.34121 6.73598 6.27511 6.90231 6.27511H8.15668C8.32301 6.27511 8.48258 6.34121 8.60021 6.45881C8.71785 6.57645 8.78391 6.73598 8.78391 6.90231V10.9791H9.88151C10.0478 10.9791 10.2074 11.0452 10.325 11.1628C10.4426 11.2804 10.5087 11.44 10.5087 11.6063C10.5087 11.7726 10.4426 11.9322 10.325 12.0498C10.2074 12.1674 10.0478 12.2335 9.88151 12.2335Z" fill="#3C3C3C"/>
				</g>
				<defs>
					<clipPath id="clip0_2157_250">
						<rect width="16" height="16" fill="white"/>
					</clipPath>
				</defs>
			</svg>

		</button>

	</div>
	<ng-container
			*ngIf="showCustomOptions && product.customSizeProfileEnabled
		&& product.customSizeProfile
		&& product.customSizeProfile?.customSizeProfileItemList
		&& product.customSizeProfile.customSizeProfileItemList.length > 0">
			<div class="fb-disclaimer-box flex items-center gap-2 my-2">
				<span class="material-symbols-outlined">error</span>
				<p>{{product.customSizeProfile.disclaimer}}</p>
			</div>
			<form (ngSubmit)="onCustomSizeSubmit()"
				  [formGroup]="customSizeFormGroup"
				  class="grid grid-cols-2 md:flex justify-start items-center flex-wrap gap-2">
				<div *ngFor="let custom of product.customSizeProfile.customSizeProfileItemList"
					 class="flex flex-col gap-1 " >
					<label for="" class="text-sm">
						{{custom.label}} <sup *ngIf="custom.mandatory" class="text-red-600 font-bold">*</sup>
					</label>
					<input [type]="custom.fieldType==1?'number':'text'"
						   [formControlName]="custom.label"
						   class="w-full p-1 fb-size-input"
						   [placeholder]="custom.placeholder">
				</div>
				<button class="mt-2 flex flex-col">
					<div *ngIf="product.customSizeProfile.customSizeProfileItemList.length % 3 !== 0"
						 class="text-xs opacity-0 hidden md:block">
						Add
					</div>
					<div class="fb-size-btn submit">Submit Custom {{product.productGroup === 'finished' ? 'Size' : 'Dye'}}</div>
				</button>
				<span *ngIf="showErrorMessage" class="text-red-600 text-sm">Please fill all the required fields</span>
			</form>
		</ng-container>
</div>
